import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Paper } from '@material-ui/core';
import { Dispatch, iRootState } from '../redux/store';
import { QuoteStatuses } from '../constants';
import QuoteFooter from './QuoteFooter';
import useStyles from '../useStyles';

const Quote = function Quote(): React.ReactElement {
  const classes = useStyles();

  const dispatch = useDispatch<Dispatch>();
  const quoteHtml = useSelector((state: iRootState) => state.quote.html);
  const isAccepted = useSelector(
    (state: iRootState) => state.quote.status === QuoteStatuses.Accepted
  );
  const isLoading = useSelector(
    (state: iRootState) => state.loading.effects.quote.getQuoteDocument
  );

  useEffect(() => {
    if (isAccepted && !isLoading) {
      dispatch.quote.signQuote();
    }
  }, [dispatch.quote, isAccepted, isLoading]);

  return (
    <>
      <Container className={classes.largeContainer}>
        <Paper className={classes.paperContainer}>
          {/*  eslint-disable-next-line react/no-danger */}
          <div dangerouslySetInnerHTML={{ __html: quoteHtml }} />
        </Paper>
      </Container>
      <QuoteFooter />
    </>
  );
};

export default Quote;
